module.exports = __webpack_public_path__ + "static/elementos-ir-1140-e4bb1025cc6cb70cbe56e1443b6eed34.jpg";